import { Component } from '@angular/core';
import { AuthResponse, AuthService, LoginCredential } from '../auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

@Component({
    selector: 're-auth',
    templateUrl: './re-auth.component.html',
    styleUrls: ['./re-auth.component.css'],
    standalone: false
})
export class ReAuthComponent {

  password: string;
  show: boolean = false;
  showErr: boolean = false;

  constructor(private authService: AuthService, private dialog: MatDialogRef<ReAuthComponent, AuthResponse>){
  
  }



  toggle(){
    if(this.show){
      this.show = false;
    }else{
      this.show = true;
    }
  }

  close(){
    this.dialog.close(null);
  }

  async onReAuth(form: NgForm){

    let credential: LoginCredential ={
      email: 'place hholder',
      password: form.value.password
    }
    try {
       
      let response = await this.authService.reAuthenticate(credential);
      if(response && !response.error){
        this.dialog.close(response); // or emit an event if not using Material
      }
      
     
    } catch (err) {
      this.showErr = true;
    }
  }

}
